const i18n = {
  title: 'Setting up automatic activity distribution',
  description: 'Configure settings for automatic activity distribution.',
  filters: 'Criteria',
  'filters.distance': 'Distance',
  'filters.schedule': 'Availability',
  'filters.all_users': 'All users',
  'filters.related_users': 'Related users',
  daysLimit: 'Days limit',
  distanceRadius: 'Distance'
}

export default i18n
